import React from "react";
import { LinearProgress } from "@mui/material";
import TabelaV2 from "../../../../../../componentsv2/Tabela";
import Box from "../../../../../../componentsv2/Box";

import OpcoesTabela from "../../../../Components/OpcoesTabela";
import BadgeSituacaoAgendamento from "../../../../Components/BadgeSituacaoAgendamento";

export default function Tabela({ rows, atualizarTabela }) {
  const columns = [
    {
      field: "situacao",
      headerName: "Situação",
      headerAlign: "center",
      align: "center",
      width: 140,
      renderCell: ({ value }) => <BadgeSituacaoAgendamento situacao={value} />,
    },
    {
      field: "username",
      valueGetter: ({ row }) => row?.usuario?.username,
      headerName: "Usuário",
      headerAlign: "center",
      align: "center",
      width: 100,
    },
    {
      field: "nome_usu",
      valueGetter: ({ row }) =>
        row?.enfermeiro?.usuario?.funcionario?.nome_usu
          .split(" ")[0]
          .toUpperCase(),
      headerName: "Enfermeiro",
      headerAlign: "center",
      align: "center",
      width: 140,
    },
    {
      field: "hora",
      headerName: "Hora",
      headerAlign: "center",
      align: "center",
      width: 100,
    },
    {
      field: "cliente",
      valueGetter: ({ row }) => row?.cliente?.nome,
      headerName: "Cliente",
      headerAlign: "center",
      align: "center",
      flex: 1,
      minWidth: 220,
    },
    {
      field: "progresso",
      headerName: "Progresso",
      headerAlign: "left",
      align: "left",
      width: 175,
      sortable: false,
      renderCell: ({ row }) => {
        const realizadas = row?.progresso?.realizadas ?? 0;
        const total = row?.progresso?.total ?? 0;
        const percentual = total > 0 ? (realizadas / total) * 100 : 0;
        const concluido = total > 0 && realizadas >= total;

        if (total === 0) {
          return <span style={{ fontSize: "12px", color: "#9E9E9E" }}>—</span>;
        }

        const labelSessoes = total === 1 ? "sessão" : "sessões";

        return (
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              gap: "6px",
            }}
          >
            <LinearProgress
              variant="determinate"
              value={percentual}
              sx={{
                width: "100%",
                height: 8,
                borderRadius: 4,
                backgroundColor: "#E0E0E0",
                "& .MuiLinearProgress-bar": {
                  backgroundColor: concluido ? "#43A047" : "#003399",
                },
              }}
            />
            <span style={{ fontSize: "11px", color: "#616161", lineHeight: 1.2 }}>
              {realizadas} de {total} {labelSessoes}
            </span>
          </div>
        );
      },
    },
    {
      field: "opcoes",
      headerName: "Opções",
      headerAlign: "center",
      align: "center",
      width: 100,
      sortable: false,
      disableClickEventBubbling: true,
      renderCell: (params) => (
        <div style={{ cursor: "pointer" }}>
          <OpcoesTabela atualizarTabela={atualizarTabela} row={params.row} />
        </div>
      ),
    },
  ];

  return (
    <Box sx={{ height: "calc(100vh - 220px)", minHeight: 560, width: "100%" }}>
      <TabelaV2
        columns={columns}
        rows={rows}
        autoPageSize
        ocultarToolbar
        sx={{
          ".MuiDataGrid-row": {
            ":nth-of-type(odd)": {
              backgroundColor: "#FFF",
            },
          },
          "& .MuiDataGrid-cell": {
            display: "flex",
            alignItems: "center",
          },
        }}
      />
    </Box>
  );
}
